import { configureApiClient } from '@trading/infrastructure/src/api/axios'
import { defineNuxtPlugin } from 'nuxt/app'
import { useAuthStore } from '~/stores/Auth'

export default defineNuxtPlugin(() => {
  const { apiBase } = useEndpoints()

  configureApiClient({
    baseUrl: apiBase,
    getToken: async () => {
      if (import.meta.server) {
        return null
      }

      // Store создаём лениво: его setup создаёт feature query, а Axios к этому
      // моменту уже должен быть сконфигурирован.
      const token = await useAuthStore().getToken()
      return token ? `Bearer ${token}` : null
    },

    onUnauthorized: () => {
      if (import.meta.server) {
        return null
      }
      // authStore.logout()
    }
  })
})
